import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function Seo({
  title = 'Lyn Entreprenør ApS',
  description = 'Effektive maskiner til dit byggeprojekt. Lyn Entreprenør ApS - din pålidelige partner inden for jordarbejde på Fyn.',
  ogImage = 'https://assets.auxodev.dk/assets/a2a4e36d-8b70-41e2-a1fb-0085c6465cf9/fulllogo-nobuffer-5_1e74d9a2.png',
  canonicalUrl,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  )
}
